import { useState, useMemo } from "react";

import Error from "core/components/Error";
import ConfirmModal from "core/components/ConfirmModal";
import Typography from "core/components/Typography";
import { downloadJson } from "./util";
import { useParams } from "react-router";
import { Input } from "core/components/Form/styles";
import { toast } from "sonner";
import useActiveMembership from "core/hooks/useActiveMembership";

const DownloadNewCredentialModal = ({
  title,
  content,
  credSettings,
  close,
}) => {
  const params = useParams();
  const {
    activeMembership: { id: organizationId },
  } = useActiveMembership();
  const { userId } = params;

  const [error, setError] = useState(null);
  const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);

  const { generateCredential, toasterMessage, getFileName, onMutationSuccess } =
    credSettings;

  const [confirmationText, setConfirmationText] = useState(null);
  const isValid = useMemo(
    () => confirmationText === "CONFIRM",
    [confirmationText]
  );

  const onNo = () => {
    setError(null);
    close();
  };

  const onYes = async () => {
    if (!isValid) {
      setError("Incorrect confirmation text.");
      return;
    }
    setError(null);
    setIsDownloadInProgress(true);

    try {
      const result = await generateCredential({ userId, organizationId });
      const credential = result.credential;
      const fileName = getFileName(credential);

      downloadJson(credential, `credential-${fileName}`);
      setIsDownloadInProgress(false);

      onMutationSuccess && onMutationSuccess();

      toast.success(toasterMessage);

      close();
    } catch (error) {
      console.error(error);
      setError(error);
      setIsDownloadInProgress(false);
    }
  };

  return (
    <ConfirmModal
      dataTest="download-credential-modal"
      visible={true}
      onNo={onNo}
      noLabel="Cancel"
      onYes={onYes}
      yesLabel="Download"
      isSubmitting={isDownloadInProgress}
      dismiss={onNo}
      title={title}
      disabled={!isValid}
    >
      <Error>{error}</Error>
      <Typography variant="p" style={{ maxWidth: "500px" }}>
        {content}
      </Typography>
      <Typography variant="p" style={{ maxWidth: "500px" }}>
        Please type CONFIRM to proceed with the download.
      </Typography>
      <div style={{ paddingBottom: "15px" }}>
        <Input onChange={(e) => setConfirmationText(e.target.value)} />
      </div>
    </ConfirmModal>
  );
};

export default DownloadNewCredentialModal;
